import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`Adds a product variant in the given quantity to the cart.`}</p>
      <p parentName="section">{`If the cart already contains a line item for the same product variant with the same `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#lineitemmode"
        }}>{`LineItemMode`}</a>{`, custom fields, supply, and distribution channel, then only the quantity of the existing `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#lineitem"
        }}>{`LineItem`}</a>{` is increased.
If `}<inlineCode parentName="p">{`shippingDetails`}</inlineCode>{` are set, they will be merged, meaning all addresses will be present afterwards and, for address keys present in both shipping details, the quantity will be summed up.
A new line item will always be added when the `}<inlineCode parentName="p">{`externalPrice`}</inlineCode>{` or the `}<inlineCode parentName="p">{`externalTotalPrice`}</inlineCode>{` is set in this update action.`}<br parentName="p"></br>{`
`}{`The `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#lineitem"
        }}>{`LineItem`}</a>{` price is set as described in `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#lineitem-price-selection"
        }}>{`LineItem Price selection`}</a>{`.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"addLineItem"`}</inlineCode></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/api/../api/projects/carts#lineitemdraft"
          }}>{`LineItemDraft`}</a>{` - Required`}</li>
      </ul>
      <p parentName="section">{`Specific Error Codes:`}</p>
      <ul parentName="section">
        <li parentName="ul"><a parentName="li" {...{
            "href": "/api/../api/errors#orders-400-matching-price-not-found"
          }}>{`MatchingPriceNotFound`}</a></li>
        <li parentName="ul"><a parentName="li" {...{
            "href": "/api/../api/errors#orders-400-missing-tax-rate-for-country"
          }}>{`MissingTaxRateForCountry`}</a></li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      